const REFERRAL_SIDEBAR_BADGE = '+3.5K SC';

export const getReferralSidebarMarker = (
  isAuthenticated: boolean,
  unviewedRefereesCount = 0,
): string | number => {
  if (!isAuthenticated) {
    return REFERRAL_SIDEBAR_BADGE;
  }

  return unviewedRefereesCount || REFERRAL_SIDEBAR_BADGE;
};
